<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Contact" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Scroll title *"
                  v-model="scroll"
                  :messages="['The recommended number of characters is 191']"
                  :error="!!errors.contactpage_scroll_title"
                  :error-messages="errors.contactpage_scroll_title"
                  @input="delete errors.contactpage_scroll_title"
                />
                <va-input
                  label="Feedback title *"
                  v-model="feedbackTitle"
                  :messages="['he recommended number of characters is 191']"
                  :error="!!errors.contactpage_feedback_title"
                  :error-messages="errors.contactpage_feedback_title"
                  @input="delete errors.contactpage_feedback_title"
                />
                <va-input
                  label="Feedback content *"
                  v-model="feedbackContent"
                  :type="'textarea'"
                  :messages="['The recommended number of characters is 300']"
                  :error="!!errors.contactpage_feedback_content"
                  :error-messages="errors.contactpage_feedback_content"
                  @input="delete errors.contactpage_feedback_content"
                />
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      scroll: '',
      feedbackTitle: '',
      feedbackContent: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
    putData () {
      return {
        contactpage_scroll_title: this.scroll,
        contactpage_feedback_title: this.feedbackTitle,
        contactpage_feedback_content: this.feedbackContent,
      }
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    submit () {
      axios.put(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/pages/4`, this.putData)
        .then(response => {
          this.showToast('Successful update')
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          this.showToast('Error')
        })
    },
    validate () {
      axios.put(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/pages/validate/4`, this.putData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          this.errors = response.data
          if (!Object.keys(this.errors).length) {
            this.submit()
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Validate Fetch Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/pages/4`)
        .then(response => {
          // console.log(response.data)
          this.scroll = response.data.contactpage_scroll_title
          this.feedbackTitle = response.data.contactpage_feedback_title
          this.feedbackContent = response.data.contactpage_feedback_content
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
